import React, { useRef } from 'react';

import { IEmployee } from '@entities/myTeam/model/types';
import { useIsOverflowing } from '@shared/hooks';
import { UiText } from '@shared/ui';

import cls from './EmployeeCardTitle.module.css';

interface IEmployerCardTitleProps {
    cardTitle: IEmployee['name'];
}

export const EmployeeCardTitle = ({ cardTitle }: IEmployerCardTitleProps) => {
    const titleRef = useRef<HTMLSpanElement>(null);
    const { isOverflowing } = useIsOverflowing({ elRef: titleRef });
    if (!cardTitle) {
        return null;
    }

    return (
        <span
            className={cls.ellipsisOneLine}
            ref={titleRef}
            title={isOverflowing ? cardTitle : null}
        >
            <UiText tag="span" align="center" variant="mediumPlain">
                {cardTitle}
            </UiText>
        </span>
    );
};
